export const itemList = [
  {
    id: 1,
    name: "Beef Burger",
    img: "beefBurger.jpg",
    price: "3.5",
    details: "Really good seasoned beef that come from Australia.",
  },
  {
    id: 2,
    name: "Beef Sandwich Burger",
    img: "beefSandwichBurger.png",
    price: "5.5",
    details: "Rich beef steak flavour",
  },
  {
    id: 4,
    name: "Burger + Fries",
    img: "burgerPlusFries.jpg",
    price: "3",
    details:
      "These juicy mini cheeseburgers are served with delectable sweet potato fries.",
  },
  {
    id: 5,
    name: "Double Cheese Burger",
    img: "doubleCheeseburger.jpg",
    price: "3.5",
    details: "The influence of cheese taste is unmissible ",
  },
  {
    id: 8,
    name: "One Set",
    img: "oneBurgerSet.jpg",
    price: "4",
    details:
      "Flavors of a caprese salad-basil, tomato and mozzarella are captured in these juicy burgers.",
  },

  {
    id: 10,
    name: "Jet Black Burger",
    img: "jetblackburger.jpg",
    price: "3.5",
    details:
      "Smoky patty melt features smoked Gouda cheese, hot sauce-spiked onions.",
  },
  {
    id: 3,
    name: "Kebab Burger",
    img: "burgerCharming.jpg",
    price: "2.5",
    details: "Topped with nacho cheese sauce, salsa and tortilla chips.",
  },
  {
    id: 6,
    name: "Fresh Burger",
    img: "freshBurger.jpg",
    price: "3",
    details: "Also called stress free burger.",
  },
  {
    id: 9,
    name: "Spicy Burger",
    img: "spicyBurger.jpg",
    price: "4",
    details: "Fresh chillies from amazon make burger wanted more and more! ",
  },
  {
    id: 11,
    name: "Triple Beef Burger",
    img: "tripleBeefBurger.jpg",
    price: "5.5",
    details: "Really good time to taste the steak.",
  },
  {
    id: 12,
    name: "Beef Hotdog",
    img: "beefSandwich.jpg",
    price: "4.5",
    details: "Lorem ipsum dolor sit amet, consectetur adgna aliqua.",
  },
  {
    id: 7,
    name: "Fries",
    img: "fries.jpg",
    price: "1.5",
    details: "Lorem ipsum dolor sit amet, consebore et dolore magna aliqua.",
  },
];
